<template>
    <section class="related" v-if="content">
        <div class="container">
            <div class="inner">
                <span class="related_title" data-appear="a1">
                    {{$t(`${type}.related`)}}
                </span>
               <div class="list" data-appear="a2">
                   <div class="item" v-for="(card, c) in content.data" :key="c" :class="exclude === card.id ? 'hide' : ''">
                       <template v-if="type === 'creations' || type === 'spectacles' || type === 'arabitudes' ">
                           <Card :class="exclude === card.id ? 'hide' : ''"
                               :id="card.id"
                               :title="card.general_info[0].event_title"
                               :picture="card.general_info[0].event_main_image"
                               :summary="card.general_info[0].event_summary | str_limit(220)"
                               :to="card.slug"
                           />

                       </template>

                       <template v-if="type === 'editions'">
                           <Card :class="exclude === card.id ? 'hide' : ''"
                               :id="card.id"
                               :title="card.title"
                               :picture="card.general_info[0].edition_details_image"
                               :summary="card.general_info[0].edition_details_summary | str_limit(220)"
                               :to="card.slug"
                           />
                       </template>
                   </div>
               </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Card from "@/components/parts/Card";
    export default {
        name: "Related",
        components:{Card},
        props: {
            type: {
                type: String,
                default: 'creations'
            },
            exclude: {
                type: Number,
                default: null
            },
        },
        data(){
            return {
                content: null
            }
        },

        created() {
            this.$craft.getRelatedContent(this.type)
                .then(res => {
                    this.content = res.data;
                })
        },

        filters:{
            str_limit(value, size){
                if (!value) return '';
                value = value.toString();

                if (value.length <= size) {
                    return value;
                }
                return value.substr(0, size) + '...';
            }
        }
    }
</script>

<style scoped>

</style>
